import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleArithmetic extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);

        switch (data.type) {
            case QuestionModel.TYPE_ADDITION: {
                this.generateValuesAddition(question, data);
                break;
            }
            case QuestionModel.TYPE_SUBTRACTION: {
                this.generateValuesSubtraction(question, data);
                break;
            }
            case QuestionModel.TYPE_MULTIPLICATION: {
                this.generateValuesMultiplication(question, data);
                break;
            }
            case QuestionModel.TYPE_MULTIPLICATION_FRACTION: {
                this.generateValuesMultiplicationFraction(question, data);
                break;
            }
            case QuestionModel.TYPE_DIVISION_FRACTION:
            case QuestionModel.TYPE_DIVISION: {
                this.generateValuesDivision(question, data);
                break;
            }
            case QuestionModel.TYPE_MIXED_ARITHMETIC: {
                this.generateValuesMixed(question, data);
                break;
            }
            default :
                console.warn("unknown module type : " + data.type);
        }

        //for multi questions ensure we pick two slots
        if (question.view === QuestionModel.VIEW_STATEMENT_MULTI) {
            question.part = [];
            const arr = P3.utils.objectToArray(data.parts);
            let rand = P3.math.randomInt(0, arr.length - 1);
            question.part.push(arr[rand]);
            arr.splice(rand, 1);
            rand = P3.math.randomInt(0, arr.length - 1);
            question.part.push(arr[rand]);
        } else {
            question.part = typeof data.parts === "number" ? data.parts : P3.utils.selectRandom(P3.utils.objectToArray(data.parts));
        }

        question.options = this.generateOptions(question, data.options || 5);
        question.xp = data.xp;

        //disable use words for questions with larger range
        //if (question.range.max > 1000) question.useWords = false;
        question.useWords = false; //now wanted that we disable entirely

        return question;
    }

    generateValuesMixed(question, data) {

        for (let i = 0; i < data.values - 1; ++i) {
            const n = Array.isArray(data.range) ? P3.math.randomInt(data.range[i].min, data.range[i].max) : P3.math.randomInt(data.range.min, data.range.max);
            question.values.push(new QuestionValue(n));
        }

        //sort values
        question.values.sort((a, b) => {
            return b.value - a.value;
        });

        //copy operands
        const ops = data.operands.slice();

        //store selected operands in question
        question.operands = [];

        let result = question.values[0].value;
        for (let i = 1; i < question.values.length; i++) {
            const opIndex = P3.math.randomInt(0, ops.length - 1);
            const op = ops[opIndex];

            switch (op) {
                case "+": {
                    result += question.values[i].value;
                    break;
                }
                case "-": {
                    result -= question.values[i].value;
                    break;
                }
                default :
                    console.warn("unsupported operand : " + op);
            }

            question.operands.push(op);

            ops.splice(opIndex, 1);
        }

        question.values.push(new QuestionValue(result));
    }

    generateValuesAddition(question, data) {
        let result = 0;
        for (let i = 0; i < data.values - 1; ++i) {
            const n = Array.isArray(data.range) ? P3.math.randomInt(data.range[i].min, data.range[i].max) : P3.math.randomInt(data.range.min, data.range.max);
            question.values.push(new QuestionValue(n));

            if (i === 0) result = n;
            else result += n;
        }
        question.values.push(new QuestionValue(result));
    }

    generateValuesSubtraction(question, data) {
        for (let i = 0; i < data.values - 1; ++i) {
            const n = Array.isArray(data.range) ? P3.math.randomInt(data.range[i].min, data.range[i].max) : P3.math.randomInt(data.range.min, data.range.max);
            question.values.push(new QuestionValue(n));
        }
        question.values.sort((a, b) => {
            return b.value - a.value;
        });

        let result = question.values[0].value;
        for (let i = 1; i < question.values.length; i++) {
            result -= question.values[i].value;
        }

        //odd edge case here.  very occasionally result can be zero, which ends up making some questions read weirdly
        //for now I will just add one to result, and remove one from last value in array
        if (result === 0) {
            result += 1;
            question.values[question.values.length - 2] = new QuestionValue(question.values[question.values.length - 2].value - 1)
        }
        question.values.push(new QuestionValue(result));
    }

    generateValuesMultiplication(question, data) {
        let result = 0;
        for (let i = 0; i < data.values - 1; ++i) {
            const n = Array.isArray(data.range) ? P3.math.randomInt(data.range[i].min, data.range[i].max) : P3.math.randomInt(data.range.min, data.range.max);
            question.values.push(new QuestionValue(n));

            if (i === 0) result = n;
            //else result *= n;

            else result = Math.round(result * n);       // we do this because of floating point errors, such as 2.3 * 100 = 229.99999999999997
        }
        question.values.push(new QuestionValue(result));
    }

    generateValuesDivision(question, data) {
        if (question.type === QuestionModel.TYPE_DIVISION_FRACTION) {
            let result = P3.math.randomInt(data.range.min, data.range.max);
            let secondTerm, firstTerm;
            secondTerm = data.scale;
            result /= data.scale;
            firstTerm = result * secondTerm;
            question.values.push(new QuestionValue(Math.round(firstTerm)));
            question.values.push(new QuestionValue(Math.round(secondTerm)));
            question.values.push(new QuestionValue(result));
        } else {
            //safe fallback
            //if (!data.divisors) data.divisors = [2, 3, 5, 8, 10];

            //todo - client removed divisor arr, using range instead
            if (!data.div_range) data.div_range = data.range;

            //first select a divisor from the array
            //const divisor = P3.utils.selectRandom(data.divisors);
            const divisor = P3.math.randomInt(data.div_range.min, data.div_range.max);
            //pick random number in range as our result
            const result = P3.math.randomInt(data.range.min, data.range.max);
            //multiply it by divisor for first value in statement
            const firstTerm = divisor * result;

            //add our values to the value array
            question.values.push(new QuestionValue(firstTerm));
            question.values.push(new QuestionValue(divisor));
            question.values.push(new QuestionValue(result));
        }
    }

    generateValuesMultiplicationFraction(question, data) {
        const firstTerm = parseFloat(P3.math.random(data.range.min, data.range.max).toFixed(1));
        const secondTerm = data.scale;

        const result = Math.round(firstTerm * secondTerm);

        question.values.push(new QuestionValue(firstTerm));
        question.values.push(new QuestionValue(secondTerm));
        question.values.push(new QuestionValue(result));

        question.useWords = false;
    }

    generateOptions(question, count = 5, positive = true) {
        let k = 1000;
        // count = 5;
        const options = [question.answer];
        switch (question.type) {
            case QuestionModel.TYPE_MIXED_ARITHMETIC:
            case QuestionModel.TYPE_ADDITION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = -10;
                        const max = 10;
                        return Math.abs(question.answer.value + P3.math.randomInt(min, max));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                break;
            }
            case QuestionModel.TYPE_SUBTRACTION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = -8;
                        const max = 8;
                        return Math.abs(question.answer.value + P3.math.randomInt(min, max));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                break;
            }
            case QuestionModel.TYPE_MULTIPLICATION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Array.isArray(question.range) ? Math.min(question.range[0].min, -question.answer.value) : Math.min(question.range.min, -question.answer.value);
                        const max = Array.isArray(question.range) ? Math.min(question.range[0].max, question.answer.value) : Math.min(question.range.min, -question.answer.value);
                        switch (P3.math.randomInt(0, 1)) {
                            default :
                            case 0 :
                                return question.answer.value + P3.math.randomInt(min, max);
                            //case 1 : return question.answer.value + P3.math.randomInt(min, max) * 10;
                            // case 2 : return question.answer.value * 10;
                        }
                    })();
                    //console.warn(value);
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                break;
            }
            case QuestionModel.TYPE_DIVISION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(question.range.min, -question.answer.value);
                        const max = Math.max(question.range.max, question.answer.value);
                        switch (P3.math.randomInt(0, 1)) {
                            default :
                            case 0 :
                                return question.answer.value + P3.math.randomInt(min, max);
                            /*
                        case 1 :
                            return question.answer.value + P3.math.randomInt(min, max) * 10;
                        case 2 :
                            return question.answer.value * 10;
                            */
                        }
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                break;
            }
            case QuestionModel.TYPE_DIVISION_FRACTION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = 0.1;
                        const max = 0.9;
                        switch (P3.math.randomInt(0, 2)) {
                            default :
                            case 0 :
                                return parseFloat((question.answer.value + P3.math.random(min, max)).toFixed(1));
                            case 1 :
                                return parseFloat((question.answer.value + P3.math.random(min, max) / 10).toFixed(1));
                            case 2 :
                                return parseFloat(((question.answer.value + P3.math.random(0, 0.1)) / 10).toFixed(2));
                        }
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                break;
            }
            case QuestionModel.TYPE_MULTIPLICATION_FRACTION : {
                const bases = [10, 100];
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        switch (P3.math.randomInt(0, 1)) {
                            default :
                            case 0 :
                                return parseInt("" + (question.answer.value * P3.utils.selectRandom(bases)));
                            case 1 :
                                return parseInt("" + (question.answer.value / P3.utils.selectRandom(bases)));
                        }
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                break;
            }
        }
        P3.utils.shuffleArray(options);
        return options;
    }
}